const EM = "—"; // —
const EN = "–"; // –
const HORIZONTAL_BAR = "―"; // ―

function transformProseSegment(segment: string): string {
  let t = segment.replace(new RegExp(`(\\d)${EN}(\\d)`, "g"), "$1-$2");
  t = t.replaceAll(EM, ", ");
  t = t.replaceAll(EN, ", ");
  t = t.replaceAll(HORIZONTAL_BAR, ", ");
  t = t.replace(/,\s*,+/g, ",");
  t = t.replace(/ +,/g, ",");
  return t;
}

export function stripTypographicLongDashes(markdown: string): string {
  if (!markdown) return markdown;
  let out = "";
  let i = 0;
  while (i < markdown.length) {
    const open = markdown.indexOf("```", i);
    if (open === -1) {
      out += transformProseSegment(markdown.slice(i));
      break;
    }
    out += transformProseSegment(markdown.slice(i, open));
    const close = markdown.indexOf("```", open + 3);
    if (close === -1) {
      out += markdown.slice(open);
      break;
    }
    out += markdown.slice(open, close + 3);
    i = close + 3;
  }
  return out;
}
